<div class="payment-pre-used-wrapper">
  <app-payment-method-list #paymentMethod *ngIf="config?.paymentOptions?.options?.PREVIOUSPAYMENTGATEWAY" [config]="config"
                          [listConfig]="{
                            wrapClass: 'pre-used',
                            list: config?.paymentOptions?.options?.PREVIOUSPAYMENTGATEWAY,
                            type: 'radio',
                            showIcon: true,
                            prev: true,
                            selected: selectedRadio,
                            showSubmitBtn: isMobile ? true : false
                          }"
                          (submitPayment)="submit($event)" (onRadioBtn)="selectedOp=$event">
  </app-payment-method-list>
</div>


<!-- One tap otp confrimation -->
<app-module-loader moduleId="otp-confirmation" selector="app-otp-confirmation"
                  [load]="oneTapOtpPopup"
                  [outputs]="{ verified: otpVerified }">
</app-module-loader>